import { default as _91slug_937AzOn7AETiMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue?macro=true";
import { default as _91slug_93IgNzNC3ayzMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue?macro=true";
import { default as _91name_93d1d9UYz3ZHMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91paxid_93EwQnuYaLg8Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue?macro=true";
import { default as _91id_93AL8eqDkm6oMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91id_93XXuqlQLUF3Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/omdome/[id].vue?macro=true";
import { default as _91tab_93gzX2Gf96IKMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue?macro=true";
import { default as _91tab_93XfKBUpf51ZMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue?macro=true";
import { default as _91tab_93fdxiqSCVTxMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue?macro=true";
import { default as _91tab_93lCsPEZOjhrMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue?macro=true";
import { default as _91slug_93gioDcVEFmsMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/info/[slug].vue?macro=true";
import { default as _91id_93VZi96U59PRMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as _91tab_93aNMOdGgyphMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue?macro=true";
import { default as _91slug_935uVCauU2K7Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/competition/[slug].vue?macro=true";
import { default as _91slug_935gi5sMwOxBMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue?macro=true";
import { default as _91ocr_93l7GzhcHheAMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91ocr_939z4vQaqmqeMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91id_93O3kCm4xKiqMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripid_93zxgZpFbJc5Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue?macro=true";
import { default as _91step_93JB54iyjuSJMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue?macro=true";
import { default as _91slug_93mVg8LtQO40Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue?macro=true";
import { default as _91jwt_93ZZQVR8vLuFMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91tab_93oNdGFqJT7SMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue?macro=true";
import { default as indexRiFU1nfjATMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/app/index.vue?macro=true";
import { default as callbackDElnDo2byWMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue?macro=true";
import { default as blackweekqtTeG7AdFNMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue?macro=true";
import { default as _91slug_93emvwQBKkvIMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue?macro=true";
import { default as indexT5tnxZ3Y93Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue?macro=true";
import { default as bookcall0pISD8j63vMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue?macro=true";
import { default as byebyeieCSoeI5y5YIMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexf7dl7ZzrtUMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue?macro=true";
import { default as lastminuteqSIi6OPROTMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue?macro=true";
import { default as _91name_93JIefJbbc4LMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue?macro=true";
import { default as indexsxKHusoH7SMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue?macro=true";
import { default as cataloguec0AWWAZjf9Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue?macro=true";
import { default as complaint1LyfBYZVyVMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/complaint.vue?macro=true";
import { default as dinbokning_45aktuelloD3XqjyuC8Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue?macro=true";
import { default as _91slug_930f4VqS4u2eMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue?macro=true";
import { default as indexaOTFJSUrRuMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue?macro=true";
import { default as faqsPpPdvoWyuMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/faq.vue?macro=true";
import { default as _91id_93OtLXSyHzQuMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as indexWYCdhZVqmJMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91name_93BVGfIhDU8pMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as indexoZ7jGG1kGAMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexKc9KqE63GtMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue?macro=true";
import { default as grouptravelxqB79TmDDlMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue?macro=true";
import { default as index19o8RJTW2jMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue?macro=true";
import { default as lastminute65oQqzI77ZMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue?macro=true";
import { default as mapc5uNFVGUtLMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue?macro=true";
import { default as dinbokningowrMmWiz7KMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue?macro=true";
import { default as newsletter3vzTwtX5gcMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/newsletter.vue?macro=true";
import { default as offlinejnvsWdLl6yMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/offline.vue?macro=true";
import { default as failedW4gjGzBIoNMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as indexxb8M1YdzN3Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/review/index.vue?macro=true";
import { default as searchD3rSjfYSEDMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/search.vue?macro=true";
import { default as indexTedbCjyEfTMeta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as verification_45doneR40Xqs0Ff6Meta } from "/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/verification-done.vue?macro=true";
export default [
  {
    name: "tourleader-id",
    path: "/guider/:id()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "titinerary",
    path: "/dagsprogram",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "shipinfo",
    path: "/skib",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "satisfactionstatus-triptypeid",
    path: "/tilfredshed-status/:triptypeid()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "omdome",
    path: "/omdome",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "mytrip",
    path: "/din-rejse",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "info-lectures",
    path: "/info/foredrag",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "info-connections",
    path: "/info/forbindelser",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-about",
    path: "/info/om",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "fn",
    path: "/fn",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "destination-slug",
    path: "/destination/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "competition",
    path: "/konkurrence",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "category",
    path: "/kategori",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "bookflight",
    path: "/bookflight",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "book-tripid",
    path: "/bestil/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "auth",
    path: "/medlem",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "triptype-slug",
    path: "/:triptype()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "triptype-slug-tab",
    path: "/:triptype()/:slug()/:tab()",
    meta: _91tab_93oNdGFqJT7SMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/[triptype]/[slug]/[tab].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/app/index.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "auth-slug",
    path: "/medlem/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/[slug].vue")
  },
  {
    name: "auth-callback",
    path: "/medlem/callback",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/auth/callback.vue")
  },
  {
    name: "blackweek",
    path: "/blackweek",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blackweek.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/blog/index.vue")
  },
  {
    name: "book-tripid-step",
    path: "/bestil/:tripid()/:step()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/book/[tripid]/[step].vue")
  },
  {
    name: "bookcall",
    path: "/boka-samtal",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookcall.vue")
  },
  {
    name: "bookflight-tripid",
    path: "/bookflight/:tripid()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/bookflight/[tripid].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "calendar",
    path: "/kalender",
    meta: indexf7dl7ZzrtUMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/index.vue")
  },
  {
    name: "calendar-lastminute",
    path: "/kalender/afbudsrejser",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/calendar/lastminute.vue")
  },
  {
    name: "campaign-name",
    path: "/kampagne/:name()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/[name].vue")
  },
  {
    name: "campaign",
    path: "/kampagne",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/campaign/index.vue")
  },
  {
    name: "catalogue",
    path: "/katalog",
    meta: cataloguec0AWWAZjf9Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/catalogue.vue")
  },
  {
    name: "category-slug",
    path: "/kategori/:slug()",
    meta: _91slug_935gi5sMwOxBMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/category/[slug].vue")
  },
  {
    name: "competition-slug",
    path: "/konkurrence/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/competition/[slug].vue")
  },
  {
    name: "complaint",
    path: "/reklamation",
    meta: complaint1LyfBYZVyVMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/complaint.vue")
  },
  {
    name: "destination-slug-tab",
    path: "/destination/:slug()/:tab()",
    meta: _91tab_93aNMOdGgyphMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/destination/[slug]/[tab].vue")
  },
  {
    name: "dinbokning-aktuell",
    path: "/dinbokning-aktuell",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/dinbokning-aktuell.vue")
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/[slug].vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/event/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/faq.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "giftcard-id",
    path: "/gavekort/:id()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "giftcard",
    path: "/gavekort",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "hotels-name",
    path: "/hoteller/:name()",
    meta: _91name_93BVGfIhDU8pMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "hotels",
    path: "/hoteller",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/index.vue")
  },
  {
    name: "info-slug",
    path: "/info/:slug()",
    meta: _91slug_93gioDcVEFmsMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/info/[slug].vue")
  },
  {
    name: "info-about-tab",
    path: "/info/om/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/about/[tab].vue")
  },
  {
    name: "info-connections-tab",
    path: "/info/forbindelser/:tab()",
    meta: _91tab_93fdxiqSCVTxMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/connections/[tab].vue")
  },
  {
    name: "info-grouptravel",
    path: "/info/grupperejse",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/grouptravel.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/index.vue")
  },
  {
    name: "info-lectures-tab",
    path: "/info/foredrag/:tab()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/info/lectures/[tab].vue")
  },
  {
    name: "lastminute",
    path: "/afbudsrejser",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/lastminute.vue")
  },
  {
    name: "map",
    path: "/kort",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/map.vue")
  },
  {
    name: "mytrip-tab",
    path: "/din-rejse/:tab()",
    meta: _91tab_93gzX2Gf96IKMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/mytrip/[tab].vue")
  },
  {
    name: "mytrip-dinbokning",
    path: "/mytrip/dinbokning",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/mytrip/dinbokning.vue")
  },
  {
    name: "newsletter",
    path: "/nyhedsbrev",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/offline.vue")
  },
  {
    name: "omdome-id",
    path: "/omdome/:id()",
    meta: _91id_93XXuqlQLUF3Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/omdome/[id].vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "review",
    path: "/bedom-rejse",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/review/index.vue")
  },
  {
    name: "satisfactionstatus-triptypeid-paxid",
    path: "/tilfredshed-status/:triptypeid()/:paxid()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/applications/rolfsbuss-web/pages/satisfactionstatus/[triptypeid]/[paxid].vue")
  },
  {
    name: "search",
    path: "/søg",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/search.vue")
  },
  {
    name: "shipinfo-name",
    path: "/skib/:name()",
    meta: _91name_93d1d9UYz3ZHMeta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "titinerary-slug",
    path: "/dagsprogram/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/titinerary/[slug].vue")
  },
  {
    name: "tourleader-id-slug",
    path: "/guider/:id()/:slug()",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/tourleader/[id]/[slug].vue")
  },
  {
    name: "tourleader",
    path: "/guider",
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45doneR40Xqs0Ff6Meta || {},
    component: () => import("/home/ubuntu/deployments/2025-06-08-0949/rtg-monorepo/src/layers/web/pages/verification-done.vue")
  }
]